import { FC } from 'react';
import { Flex } from '@rebass/emotion';
import Loader from '@app/components/Loader';
import NotFound from '@app/components/NotFound';
import { PricingPage_content_pricing_pages_layout_item_pricing_pages_multi_layout_products_products_id as DirectusProduct } from '../../__generated__/PricingPage';
import useShopProduct from '../../hook/useShopProduct';
import ConfigurableProductTile from './ConfigurableProductTile';
import BundleProductTile from './BundleProductTile';
import VirtualProductTile from './VirtualProductTile';

interface ProductTileProps {
  product: DirectusProduct;
}

const ProductTile: FC<ProductTileProps> = ({ product }) => {
  const {
    loading,
    error,
    magentoProduct,
    isAuthenticated,
    country,
  } = useShopProduct(product);
  if (loading) {
    return (
      <Flex justifyContent="center">
        <Loader />
      </Flex>
    );
  }

  if (error) {
    throw new Error('Unable to query product data');
  }

  if (!magentoProduct) {
    return <NotFound />;
  }

  switch (magentoProduct.__typename) {
    case 'Magento2_ConfigurableProduct':
      return (
        <ConfigurableProductTile
          directusProduct={product}
          magentoProduct={magentoProduct}
          isAuthenticated={isAuthenticated}
          country={country}
        />
      );

    case 'Magento2_BundleProduct':
      return (
        <BundleProductTile
          directusProduct={product}
          magentoProduct={magentoProduct}
          country={country}
        />
      );

    case 'Magento2_VirtualProduct':
      return (
        <VirtualProductTile
          directusProduct={product}
          magentoProduct={magentoProduct}
          country={country}
        />
      );

    default:
      return <NotFound />;
  }
};

export default ProductTile;
